import { Component, output, input, signal, computed, effect, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-selection-duree',
  templateUrl: './selection-duree.component.html',
  styleUrls: ['./selection-duree.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectionDureeComponent {
  readonly dureeChange = output<number>();
  readonly dureeMaxi = input<number>(null);
  readonly heureStep = input<number>(1);
  readonly minuteStep = input<number>(5);
  readonly duree = input<number>(null);

  protected dureeValue = signal<number>(null);
  protected heure = signal<number>(0);
  protected minute = signal<number>(0);
  protected heureMaxi = signal<number>(24);

  protected readonly tabMinutes: string[] = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59']
  protected readonly tabMinutesValeur: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59];
  protected readonly tabHeures: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
  protected tabMinutesAffichees = signal<string[]>([]);
  protected tabMinutesValeurAffichees = signal<number[]>([]);

  constructor() {
    effect(() => {
      const dureeVal = this.duree();
      if (dureeVal !== null) {
        this.dureeValue.set(dureeVal);
        this.afficheHeure();
      }
    });
  }

  ngOnInit() {
    this.afficheHeure();
  }

  private afficheHeure() {
    const maxDuree = this.dureeMaxi();
    this.heureMaxi.set(!maxDuree ? 24 : (maxDuree / 3600 | 0));

    let currentHeureStep = this.heureStep();
    let currentMinuteStep = this.minuteStep();
    if (currentHeureStep > 24)
      currentHeureStep = 24;
    if (currentMinuteStep > 60)
      currentMinuteStep = 60;
    
    let currentDureeValue = this.dureeValue();
    if (currentDureeValue > 86400) {
      currentDureeValue = 86400;
      this.dureeValue.set(currentDureeValue);
      this.dureeChange.emit(currentDureeValue);
    }
    this.modifierMinutesAffichees();
    if (currentDureeValue) {
      this.heure.set(Math.floor(currentDureeValue / 3600));
      let nbMinutes = (currentDureeValue % 3600) / 60 | 0;
      // Dans le cas où nbMinutes = 4 et minuteStep = 5
      let mod = nbMinutes % currentMinuteStep;
      if (mod !== 0) {
        if (mod / currentMinuteStep > 0.5)
          nbMinutes = nbMinutes + (currentMinuteStep - nbMinutes % currentMinuteStep);
        else
          nbMinutes = nbMinutes + nbMinutes % currentMinuteStep;
      }
      // Dans le cas où un arrondi sort de l'interval 0-59
      if (nbMinutes >= 60)
        nbMinutes = 60 - currentMinuteStep;

      this.minute.set(nbMinutes);
    }
  }

  heureChangee() {
    const currentHeure = this.heure();
    const currentHeureMaxi = this.heureMaxi();
    if (currentHeure == currentHeureMaxi)
      this.minute.set(0);
    const newDuree = currentHeure * 3600 + this.minute() * 60;
    this.dureeValue.set(newDuree);
    this.dureeChange.emit(newDuree);
    this.modifierMinutesAffichees();
  }

  minuteChangee() {
    const newDuree = this.heure() * 3600 + this.minute() * 60;
    this.dureeValue.set(newDuree);
    this.dureeChange.emit(newDuree);
  }

  modifierMinutesAffichees() {
    const maxDuree = this.dureeMaxi();
    const currentHeure = this.heure();
    const currentHeureMaxi = this.heureMaxi();
    let minutesRestantes = currentHeure == currentHeureMaxi ? ((maxDuree % 3600) / 60 | 0) : 59;
    const newTabMinutes: string[] = [];
    const newTabMinutesValeur: number[] = [];
    for (var i = 0; i <= minutesRestantes; i++) {
      newTabMinutes.push(this.tabMinutes[i]);
      newTabMinutesValeur.push(this.tabMinutesValeur[i]);
    }
    this.tabMinutesAffichees.set(newTabMinutes);
    this.tabMinutesValeurAffichees.set(newTabMinutesValeur);
  }
}
